import { render, staticRenderFns } from "./printHistory.vue?vue&type=template&id=34d38f12&"
import script from "./printHistory.vue?vue&type=script&lang=js&"
export * from "./printHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports